import React from 'react';
import ChampionshipForm from '../ChampionshipForm';
import { useState } from 'react';

export default function ChampionshipTable({ title, items, userfc, activeSection, setActiveSection }) {
    const [showForm, setShowForm] = useState(false);
    return (
        showForm ?
            <div className="mt-12 w-full flex justify-center" >
                <ChampionshipForm userfc={userfc} setShowForm={setShowForm} activeSection={activeSection} setActiveSection={setActiveSection} />
            </div>
            :
        <div className="rounded-3xl shadow-xl overflow-hidden border border-gray-200 bg-white md:w-[90%] w-[90%] mx-auto mt-8">
            <div className="flex justify-between items-center border-b bg-gradient-to-r from-gray-50 to-gray-100 p-6">
                <h4 className="text-xl font-bold interf text-gray-900">{title}</h4>
                <button className='bg-green-600 hover:bg-green-700 px-4 py-2 interf text-white rounded-lg'  onClick={() => setShowForm(true)}>Add New</button>
            </div>
            {items.length === 0 && (
                <div className="p-8 text-center text-gray-500">
                    No registrations yet. Click "Add New" to add one.
                </div>
            )}
            <div className="overflow-x-auto">
                <table className="min-w-full">
                    <thead>
                        <tr className="border-b bg-gradient-to-r from-gray-50 to-gray-100">
                            <th className="px-6 py-3 text-left text-xs font-semibold text-gray-600 uppercase">Name</th>
                            <th className="px-6 py-3 text-left text-xs font-semibold text-gray-600 uppercase">Class</th>
                            <th className="px-6 py-3 text-left text-xs font-semibold text-gray-600 uppercase">Category</th>
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-200">
                        {items.map((item, index) => (
                            <tr key={item._id || index} className="group hover:bg-gray-50">
                                <td className="px-6 py-4 whitespace-nowrap">
                                    <div className="flex items-center">
                                        <div className="h-10 w-10 relative">
                                            <div className="absolute inset-0 bg-gradient-to-r from-gray-100 to-gray-200 rounded-full p-[2px]">
                                                <img
                                                    src={item.photo || 'https://static.vecteezy.com/system/resources/thumbnails/003/337/584/small/default-avatar-photo-placeholder-profile-icon-vector.jpg'}
                                                    alt={item.name}
                                                    className="h-full w-full rounded-full object-cover border border-white"
                                                />
                                            </div>
                                        </div>
                                        <div className="ml-4">
                                            <div className="text-sm font-semibold text-gray-900">{item.name}</div>
                                            <div className="text-xs text-gray-500">Registered Fighter</div>
                                        </div>
                                    </div>
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap">
                                    <span className="px-4 py-1.5 rounded-full bg-blue-100 text-blue-700 text-xs font-medium border border-blue-200">
                                        {item.class}
                                    </span>
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap">
                                    <span className="px-4 py-1.5 rounded-full bg-green-100 text-green-700 text-xs font-medium border border-green-200">
                                        {item.category}
                                    </span>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
} 